export default __webpack_public_path__ + "static/media/token3.a0bb74b6.png";